import { render, staticRenderFns } from "./Grand.vue?vue&type=template&id=387784d4"
import script from "./Grand.vue?vue&type=script&lang=js"
export * from "./Grand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports